import {
    AddressForm,
    AutocompleteAddressParams,
} from "../domain/models/dto/AddressDTO";
import {
    AutocompletedWorkDTO,
    AutocompleteWorkTitleParams,
} from "../domain/models/dto/WorkDTO";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class AutocompleteServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static getAutocompletedWorksDataThunk = createAsyncThunkFactory<
        AutocompletedWorkDTO[],
        AutocompleteWorkTitleParams
    >(
        "AutocompleteServiceImpl.getAutocompletedWorksDataThunk",
        async (args) => {
            if (args.title.length < 5 || args.title.length > 100) {
                return;
            }
            const params = new URLSearchParams(args as any);
            return this.get("/api/v1/work/autocomplete?" + params.toString(), undefined, true);
        }
    );

    static getAutocompletedAddressDataThunk = createAsyncThunkFactory<
        AddressForm[],
        AutocompleteAddressParams
    >(
        "AutocompleteServiceImpl.getAutocompletedAddressDataThunk",
        async (args) => {
            const filteredArgs = Object.fromEntries(
                Object.entries(args).filter(([_, value]) => {
                    return (
                        !!value &&
                        typeof value === "string" &&
                        value.length >= 2
                    );
                })
            );
            const params = new URLSearchParams(filteredArgs);
            if (!params.toString()) {
                return;
            }

            params.append("page", args.page.toString());
            params.append("limit", args.limit.toString());
            params.append("offset", args.offset.toString());
            return this.get(
                "/api/v1/address/autocomplete?" + params.toString(),
                undefined,
                true
            );
        }
    );
}
